import axios from "axios";

import Config from "src/config";

const v2_actionBuscarDadosCliente = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/clientes/${clienteId}/detalhes${querys ? querys : ""}`,
    });
};

export default v2_actionBuscarDadosCliente;
